import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  TablePagination,
  TableContainer,
  Modal,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Breadcrumbs,
  Tooltip,
  Paper,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  Fade,
  Switch,
  FormControlLabel,
  TableSortLabel,
} from "@mui/material";
import { useNavigate } from "react-router";
import "./Booklist.css";
import api from "../axiosInstance";
import { isMarketingUser, getCurrentRoles } from "../auth";
import { canAccess } from "../permissions";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { BUTTON_STYLES } from "../styles/componentStyles";
import CanAccess from "./access/CanAccess";
import SourceIcon from "@mui/icons-material/Source";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { toast, ToastContainer } from "react-toastify";
import { logDOM } from "@testing-library/react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";

const columns = [
  {
    id: "id",
    label: "ID",
    sortable: true,
    filterable: true,
    css: { minWidth: "100px" },
  },
  {
    id: "title",
    label: "Title",
    sortable: true,
    filterable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "university",
    label: "University",
    sortable: true,
    filterable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "course",
    label: "Course Name",
    sortable: true,
    filterable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "regulation",
    label: "Regulation",
    sortable: true,
    filterable: true,
    css: { minWidth: "200px" },
  },
  {
    id: "Semester",
    label: "Semester",
    sortable: true,
    filterable: true,
    css: { minWidth: "200px" },
  },
  {
    id: "abbreviation",
    label: "Abbreviation",
    sortable: true,
    filterable: true,
    css: { minWidth: "200px" },
  },
  {
    id: "price",
    label: "Price",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "discount",
    label: "Discount",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "rating",
    label: "Rating",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "requestable",
    label: "Requestable",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "viewable",
    label: "Viewable",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },

  {
    id: "active",
    label: "Active",
    filterable: true,
    sortable: true,
    css: { minWidth: "150px" },
  },
  {
    id: "actions",
    label: "Actions",
    sortable: false,
    css: {
      minWidth: "150px",
      position: "sticky",
      right: 0,
      zIndex: 2,
    },
  },
];

const Books_part_types = [
  { value: "SYLLABUS", label: "Syllabus" },
  { value: "FAQS", label: "FAQs" },
  { value: "MODEL_QP", label: "Model Question Paper" },
  { value: "EXAM_QP", label: "Exam Question Paper" },
  { value: "WEIGHTAGE", label: "Weightage" },
  { value: "QUESTIONANDANSWER", label: "Question & Answers" },
  {
    value: "LMR_SHORT_QUESTION_ANSWER",
    label: "Lmr Short Answer Questions",
  },
  {
    value: "LMR_LONG_QUESTION_ANSWER",
    label: "Lmr Question & Answers",
  },
  { value: "SUMMARY", label: "Summary" },
  { value: "LECTURENOTES", label: "Lecture Notes" },
  { value: "LECTURENOTESSUMMARY", label: "Lecture Notes Summary" },
  {
    value: "LECTURENOTESINTERNALASSESSMENT",
    label: "Lecture Notes Internal Assessment",
  },
  { value: "VIDEOS", label: "Videos" },
  { value: "PDFS", label: "Pdfs" },
  { value: "TIPS_TRICKS", label: "Tips Tricks" },
];

const whiteSortLabelSx = {
  color: "white !important",
  "&.Mui-active": { color: "white !important" },
  "&:hover": { color: "white !important" },
  "& .MuiTableSortLabel-icon": { color: "white !important" },
};
const BookDetails = ({ roles }) => {
  console.log("Roles:", roles?.roles);

  const [books, setBooks] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Helper function to check if user has any admin permissions
  const hasAdminAccess = () => {
    return (
      canAccess("ADMIN_ROLES_PAGE") ||
      canAccess("ADMIN_UI_PERMISSIONS_PAGE") ||
      canAccess("ADMIN_API_MANAGEMENT_PAGE") ||
      canAccess("ADMIN_PASSWORDS_PAGE")
    );
  };
  const hasEditorAccess = () => {
    return canAccess("ROUTE_BOOKLIST");
  };
  const hasAllFormatAccess = () => {
    return canAccess("ADMIN_BUTTON");
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [openReprocess, setOpenReprocess] = useState(false);
  const [selectedBookForReprocess, setSelectedBookForReprocess] =
    useState(null);
  const [isBulkReprocess, setIsBulkReprocess] = useState(false);
  const [bookPartType, setBookPartType] = useState("");
  const [bookPartTypesList, setBookPartTypesList] = useState([]);
  const [isReprocessing, setIsReprocessing] = useState(false);
  const [isIndexing, setIsIndexing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openDuplicate, setOpenDuplicate] = useState(false);
  const [selectedBookForDuplicate, setSelectedBookForDuplicate] =
    useState(null);
  const [newBookTitle, setNewBookTitle] = useState("");
  const [isDuplicating, setIsDuplicating] = useState(false);
  const [titleSearch, setTitleSearch] = useState("");
  const [courseSearch, setCourseSearch] = useState("");
  const [universitySearch, setUniversitySearch] = useState("");
  const [regulationsSearch, setRegulationsSearch] = useState("");
  const [dense, setDense] = useState(true);
  const [selectDuplicate, setSelectDuplicate] = useState("");
  const [bookPartTypes, setBookPartTypes] = useState([]);
  const handleNewOpen = () => {
    navigate("/bookform", {
      state: {
        isEdit: false,
        bookData: null,
      },
    });
  };

  const handleEditOpen = (book) => {
    navigate("/bookform", {
      state: {
        isEdit: true,
        bookData: book,
      },
    });
  };

  const handleDuplicateOpen = (book) => {
    setSelectedBookForDuplicate(book);
    setNewBookTitle(`${book.title} (Copy)`);
    setOpenDuplicate(true);
  };

  const handleDuplicateClose = () => {
    setSelectedBookForDuplicate(null);
    setNewBookTitle("");
    setOpenDuplicate(false);
  };
  const navigate = useNavigate();
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    handleBookList();
    // Fetch book part types for reprocessing
    api
      .get("/bookPartTypes")
      .then((response) => {
        setBookPartTypesList(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching book part types", error);

        // Fallback to hardcoded list if API fails
        setBookPartTypesList([
          { value: "SYLLABUS", label: "Syllabus" },
          { value: "FAQS", label: "FAQs" },
          { value: "MODEL_QP", label: "Model Question Paper" },
          { value: "EXAM_QP", label: "Exam Question Paper" },
          { value: "WEIGHTAGE", label: "Weightage" },
          { value: "QUESTIONANDANSWER", label: "Question & Answers" },
          {
            value: "LMR_SHORT_QUESTION_ANSWER",
            label: "Lmr Short Answer Questions",
          },
          {
            value: "LMR_LONG_QUESTION_ANSWER",
            label: "Lmr Question & Answers",
          },
          { value: "SUMMARY", label: "Summary" },
          { value: "LECTURENOTES", label: "Lecture Notes" },
          { value: "LECTURENOTESSUMMARY", label: "Lecture Notes Summary" },
          {
            value: "LECTURENOTESINTERNALASSESSMENT",
            label: "Lecture Notes Internal Assessment",
          },
          { value: "VIDEOS", label: "Videos" },
          { value: "PDFS", label: "Pdfs" },
          { value: "TIPS_TRICKS", label: "Tips Tricks" },
        ]);
      });
  }, []);

  const handleRowClick = (event, id) => {
    if (event.target.type !== "checkbox") {
      navigate(`/selectedbook/${id}`);
    }
  };

  const handleCheckboxChange = (event, bookId) => {
    if (event.target.checked) {
      setSelectedBooks((prevSelected) => [...prevSelected, bookId]);
    } else {
      setSelectedBooks((prevSelected) =>
        prevSelected.filter((id) => id !== bookId),
      );
    }
  };

  const handleBookList = () => {
    setIsLoading(true);
    setError(null);
    api
      .get("/api/v1/allBooks")
      .then((response) => {
        setBooks(response.data.data);
        setError(null);
        // Debug: Log first book to see data structur
        if (response.data.data && response.data.data.length > 0) {
          console.log("Sample book data:", response.data.data[0]);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the book details!", error);
        setError("Failed to load books. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedBooks([]);
    } else {
      setSelectedBooks(books.map((book) => book.id));
    }
    setSelectAll(!selectAll);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCourseBookMapping = (event, id) => {
    if (event.target.type !== "checkbox") {
      navigate(`/courseBookMapping`);
    }
  };
  // New Update button redirection
  const handlenewUpdates = (event, id) => {
    if (event.target.type !== "checkbox") {
      navigate(`/updates`);
    }
  };
  const handleReprocessOpen = (book) => {
    setIsBulkReprocess(false);
    setSelectedBookForReprocess(book);
    setBookPartType("");
    setOpenReprocess(true);
  };

  const handleBulkReprocessOpen = () => {
    setIsBulkReprocess(true);
    setSelectedBookForReprocess(null);
    setBookPartType("");
    setOpenReprocess(true);
  };

  const handleReprocessClose = () => {
    setOpenReprocess(false);
    setIsBulkReprocess(false);
    setSelectedBookForReprocess(null);
    setBookPartType("");
  };

  const handleReprocess = async () => {
    if (
      !bookPartType ||
      (isBulkReprocess ? !selectedBooks.length : !selectedBookForReprocess)
    ) {
      toast.error("Please select a book part type");
      return;
    }

    setIsReprocessing(true);
    try {
      toast.info("Book reprocessing initiated!", {
        autoClose: 2000,
      });

      if (isBulkReprocess) {
        await api.post("/parse/reprocess", {
          bookIds: selectedBooks,
          bookPartTypes: [bookPartType],
        });
      } else {
        await api.get(
          `/parse/processFileFromDB/${selectedBookForReprocess.id}?bookparttype=${bookPartType}`,
        );
      }

      toast.success("Book reprocessed successfully!", {
        autoClose: 3000,
      });
      handleReprocessClose();
    } catch (error) {
      console.error("Error reprocessing book:", error);
      setError(
        error.response?.data?.errorMessage ||
          "Error reprocessing book. Please try again.",
      );
    } finally {
      setIsReprocessing(false);
      setSelectedBooks([]);
    }
  };

  // Index a single selected book into RAG
  const handleIndexProcess = async () => {
    if (selectedBooks.length === 0) {
      toast.warning("Please select a book to index");
      return;
    }
    if (selectedBooks.length > 1) {
      toast.warning("Please select only one book to index");
      return;
    }
    const bookId = selectedBooks[0];
    setIsIndexing(true);
    try {
      await api.post(`/api/v1/rag/index/book/${bookId}`);
      toast.success("Book indexed successfully!", { autoClose: 3000 });
    } catch (error) {
      console.error("Error indexing book:", error);
      toast.error(
        error.response?.data?.errorMessage ||
          "Error indexing book. Please try again.",
      );
    } finally {
      setIsIndexing(false);
      setSelectedBooks([]);
    }
  };

  const handleDuplicateBook = async () => {
    if (!selectedBookForDuplicate || !newBookTitle.trim()) {
      toast.error("Please enter a title for the duplicated book");
      return;
    }

    setIsDuplicating(true);
    try {
      const response = await api.post(
        `/api/v1/books/${selectedBookForDuplicate.id}/duplicate`,
        {
          newTitle: newBookTitle.trim(),
          bookPartTypes: bookPartTypes,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200 && response.data.isError === false) {
        const newBookId = response.data.data.id;
        toast.success(
          `Book duplicated successfully! Redirecting to new book...`,
          {
            autoClose: 3000,
          },
        );

        // Close the modal
        handleDuplicateClose();

        // Redirect to the new book's upload page
        setTimeout(() => {
          navigate(`/selectedbook/${newBookId}`);
        }, 1500);
      } else {
        toast.error("Failed to duplicate book. Please try again.");
      }
    } catch (error) {
      console.error("Error duplicating book:", error);
      const errorMessage =
        error.response?.data?.errorMessage ||
        error.response?.data?.message ||
        "Error duplicating book. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsDuplicating(false);
    }
  };
  //  Send the Book details to Books Content Page
  const handleBookConetnt = (bookData) => {
    navigate("/booksContent", { state: { data: bookData } });
  };
  // Send the Book details to Books files Page
  const handleBookFiles = (BookId, BookTitle) => {
    navigate("/booksfiles", {
      state: { bookId: BookId, Booktitle: BookTitle },
    });
  };

  // Helper function to get status chip styling based on book properties
  const getStatusChip = (book) => {
    // If requestable is true, always show "Requestable" regardless of active/viewable
    if (book.requestable === true) {
      return <Chip label="Requestable" color="warning" size="small" />;
    }

    // If requestable is false, fall back to active status
    if (book.active === true) {
      return <Chip label="Active" color="success" size="small" />;
    } else if (book.active === false) {
      return <Chip label="Inactive" color="error" size="small" />;
    } else {
      // Fallback for undefined/null active status
      return <Chip label="Unknown" color="default" size="small" />;
    }
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    return (
      <Chip
        label={value ? "Yes" : "No"}
        color={value ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };

  // Column-specific filters
  // Load saved filters from localStorage
  const savedFilters =
    JSON.parse(localStorage.getItem("bookColumnFilters")) || {};

  // Initialize column filters
  const [columnFilters, setColumnFilters] = useState(savedFilters);

  // Tracks which filter input is open per column
  const [filterOpen, setFilterOpen] = useState(() =>
    columns.reduce((acc, col) => {
      acc[col.id] = savedFilters[col.id] ? true : false;
      return acc;
    }, {}),
  );

  // Load saved filters from localStorage on mount
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("bookColumnFilters"));
    if (savedFilters) {
      setColumnFilters((prev) => ({ ...prev, ...savedFilters }));
    }
  }, []);

  // Save filters to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("bookColumnFilters", JSON.stringify(columnFilters));
  }, [columnFilters]);

  const handleColumnFilterChange = (columnId, value) => {
    // Store the raw string so input works
    setColumnFilters((prev) => ({
      ...prev,
      [columnId]: value,
    }));

    // If the input is not empty, keep the filter open
    if (value.trim() !== "") {
      setFilterOpen((prev) => ({ ...prev, [columnId]: true }));
    }
  };

  const toggleFilter = (columnId) => {
    setFilterOpen((prev) => ({ ...prev, [columnId]: !prev[columnId] }));
  };
  // Book filtering code
  const Bookfiltering = books.filter((book) =>
    columns.every((col) => {
      const filterValue = columnFilters[col.id];
      if (filterValue === "" || filterValue == null) return true; // skip empty filters

      let cellValue = "";
      switch (col.id) {
        case "university":
          cellValue =
            book.courseRegulations?.map((c) => c.universityName).join(", ") ||
            "";
          break;
        case "course":
          cellValue =
            book.courseRegulations?.map((c) => c.courseName).join(", ") || "";
          break;
        case "regulation":
          cellValue =
            book.courseRegulations?.map((c) => c.regulationName).join(", ") ||
            "";
        case "Semester":
          cellValue =
            book.courseRegulations?.map((c) => c.semesterName).join(", ") || "";
          break;
        default:
          cellValue = book[col.id];
      }

      // Boolean columns
      if (["active", "viewable", "requestable"].includes(col.id)) {
        if (filterValue === "yes") return cellValue === true;
        if (filterValue === "no") return cellValue === false;
        return true; // ignore invalid input
      }

      // String comparison
      return String(cellValue)
        .toLowerCase()
        .includes(filterValue.toString().toLowerCase());
    }),
  );

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  //  Sorting with Table Headers
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [filterOn, setFilterOn] = useState(true);

  // Sort handler
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Sort logic
  const sortedBooks = [...Bookfiltering].sort((a, b) => {
    if (!orderBy) return 0;

    const getValue = (item) => {
      switch (orderBy) {
        case "publisher":
          return item.publisher?.name || "";
        case "course":
          return (
            item.courseRegulations?.map((c) => c.courseName).join(", ") || ""
          );
        case "regulation":
          return (
            item.courseRegulations?.map((c) => c.regulationName).join(", ") ||
            ""
          );
        default:
          return item[orderBy] ?? "";
      }
    };

    let aValue = getValue(a);
    let bValue = getValue(b);

    // Convert boolean strings to actual boolean
    if (["active", "viewable", "requestable"].includes(orderBy)) {
      aValue = aValue === true ? 1 : 0;
      bValue = bValue === true ? 1 : 0;
    }

    // Detect numbers
    const aNum = parseFloat(aValue);
    const bNum = parseFloat(bValue);
    const aIsNum = !isNaN(aNum);
    const bIsNum = !isNaN(bNum);

    if (aIsNum && bIsNum) {
      // Numeric comparison
      return order === "asc" ? aNum - bNum : bNum - aNum;
    } else {
      // String comparison (case-insensitive)
      aValue = String(aValue).toLowerCase();
      bValue = String(bValue).toLowerCase();
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    }
  });

  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <ToastContainer />

      {/* Header Section */}
      {/* <Card sx={{ mb: 3, boxShadow: 2 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box>
              <Typography
                variant="h4"
                component="h1"
                sx={{ fontWeight: 600, color: "primary.main" }}
              >
                Books List
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={handleBookList}
              disabled={isLoading}
              sx={{ minWidth: 120 }}
            >
              {isLoading ? <CircularProgress size={20} /> : "Refresh"}
            </Button>
          </Box>

          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            {hasEditorAccess() && (
              <Button
                variant="outlined"
                onClick={handleCourseBookMapping}
                {...BUTTON_STYLES.secondary}
              >
                Course Book Mapping
              </Button>
            )}
            {(canAccess("DB_DATA_BUTTON") || canAccess("DB_DATA_PAGE")) && (
              <Button
                variant="outlined"
                onClick={() => navigate("/dbdata")}
                {...BUTTON_STYLES.secondary}
              >
                DB Data
              </Button>
            )}
            <CanAccess component="COUPONS_BUTTON">
              <Button
                variant="outlined"
                onClick={() => navigate("/Coupons")}
                {...BUTTON_STYLES.secondary}
              >
                Coupons
              </Button>
            </CanAccess>
            <CanAccess component="NEWS_UPDATES_BUTTON">
              <Button
                variant="outlined"
                onClick={handlenewUpdates}
                {...BUTTON_STYLES.secondary}
              >
                News & Updates
              </Button>
            </CanAccess>
            {hasAdminAccess() && (
              <Button
                variant="outlined"
                onClick={() => navigate("/FaqManagement")}
                {...BUTTON_STYLES.secondary}
              >
                FAQ
              </Button>
            )}
            {hasAdminAccess() && (
              <Button
                variant="outlined"
                onClick={() => navigate("/TestimonialManagement")}
                {...BUTTON_STYLES.secondary}
              >
                Testimonials
              </Button>
            )}
            {hasAdminAccess() && (
              <Button
                variant="outlined"
                onClick={() => navigate("/BannerManagement")}
                {...BUTTON_STYLES.secondary}
              >
                Banners
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={() => navigate("/notification")}
              {...BUTTON_STYLES.secondary}
            >
              Notification
            </Button>

            {hasAllFormatAccess() && (
              <Button
                variant="outlined"
                onClick={() => navigate("/admin/dashboard")}
                startIcon={<AdminPanelSettingsIcon />}
                {...BUTTON_STYLES.secondary}
                sx={{
                  borderColor: "#9c27b0",
                  color: "#9c27b0",
                  "&:hover": {
                    borderColor: "#7b1fa2",
                    backgroundColor: "rgba(156, 39, 176, 0.04)",
                  },
                }}
              >
                Admin Management
              </Button>
            )}
          </Stack>
        </CardContent>
      </Card> */}

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // column on mobile, row on desktop
          justifyContent: { xs: "flex-start", md: "space-between" }, // start on mobile, space-between on desktop
          alignItems: { xs: "stretch", md: "center" }, // stretch on mobile, center on desktop
          gap: { xs: 1, md: 0 }, // spacing between items
          mb: 2,
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Dashboard
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Books List
          </Typography>
        </Breadcrumbs>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 1,
            flexWrap: { xs: "wrap", md: "nowrap" }, // wrap buttons on mobile
            mt: { xs: 1, md: 0 },
          }}
        >
          {/* <CanAccess component="BOOK_REPROCESS_BUTTON">
            <Button
              variant="contained"
              color="secondary"
              startIcon={
                isIndexing ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <RefreshIcon />
                )
              }
              onClick={handleIndexProcess}
              disabled={selectedBooks.length !== 1 || isIndexing}
              {...BUTTON_STYLES.primary}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              {isIndexing ? "Indexing..." : "Index Process"}
            </Button>
          </CanAccess>*/}
          <CanAccess component="BOOK_REPROCESS_BUTTON">
            {selectedBooks.length > 1 ? (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<RefreshIcon />}
                onClick={handleBulkReprocessOpen}
                {...BUTTON_STYLES.primary}
                sx={{
                  minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                  fontSize: { xs: "10px", md: "12px" },
                }}
              >
                Re-process Multiple Books
              </Button>
            ) : (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<RefreshIcon />}
                onClick={() => {
                  if (selectedBooks.length === 0) {
                    toast.warning(
                      "Please select at least one book to reprocess",
                    );
                    return;
                  }
                  const selectedBook = books.find(
                    (book) => book.id === selectedBooks[0],
                  );
                  if (selectedBook) {
                    handleReprocessOpen(selectedBook);
                  }
                }}
                disabled={selectedBooks.length !== 1}
                {...BUTTON_STYLES.primary}
                sx={{
                  minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                  fontSize: { xs: "10px", md: "12px" },
                }}
              >
                Reprocess Book
              </Button>
            )}
          </CanAccess>
          <CanAccess component="BOOK_ADD_BUTTON">
            <Button
              variant="contained"
              color="primary"
              startIcon={<FactCheckIcon />}
              onClick={() => navigate("/reprocess-status")}
              {...BUTTON_STYLES.primary}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Reprocess Status
            </Button>
          </CanAccess>
          <CanAccess component="BOOK_ADD_BUTTON">
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleNewOpen}
              {...BUTTON_STYLES.primary}
              sx={{
                minWidth: { xs: "120px", md: "auto" }, // smaller on mobile
                fontSize: { xs: "10px", md: "12px" },
              }}
            >
              Add New Book
            </Button>
          </CanAccess>
        </Box>
      </Box>
      <Card sx={{ textAlign: "end" }}>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            padding: "5px",
            paddingBottom: 0,
            "&:last-child": {
              paddingBottom: 0,
            },
          }}
        >
          <Box>
            {/* Search and Filter Section */}
            {filterOn && (hasAdminAccess() || hasEditorAccess()) && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {/* <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                  <TextField
                    size="small"
                    variant="outlined"
                    label="Search Title"
                    placeholder="Search by Title..."
                    value={titleSearch}
                    onChange={(e) => setTitleSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    size="small"
                    variant="outlined"
                    label="Search Course"
                    placeholder="Search by Course..."
                    value={courseSearch}
                    onChange={(e) => setCourseSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    size="small"
                    variant="outlined"
                    label="Search University"
                    placeholder="Search by University..."
                    value={universitySearch}
                    onChange={(e) => setUniversitySearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    size="small"
                    variant="outlined"
                    label="Search Regulations"
                    placeholder="Search by Regulations..."
                    value={regulationsSearch}
                    onChange={(e) => setRegulationsSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack> */}
                <Typography variant="body2" color="text.secondary">
                  {sortedBooks.length} of {books.length} books
                </Typography>
              </Box>
            )}
          </Box>
          <Box>
            {/* Filter icon toggle */}
            {/* <Tooltip title="Fliters" arrow>
              <IconButton
                onClick={handleToggleFilter}
                color={filterOn ? "primary" : "default"}
              >
                {filterOn ? <FilterAltIcon /> : <FilterAltOffIcon />}
              </IconButton>
            </Tooltip> */}

            {/* Dense toggle */}
            <Tooltip title="Dense padding" arrow>
              <FormControlLabel
                control={
                  <Switch
                    checked={dense}
                    onChange={handleChangeDense}
                    color="primary"
                  />
                }
              />
            </Tooltip>
          </Box>
        </CardContent>
      </Card>
      {/* Error State */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {/* Table Section */}

      {!isLoading && (
        <>
          {hasAdminAccess() || hasEditorAccess() ? (
            <Fade in={!isLoading}>
              <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: 2 }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table
                    stickyHeader
                    aria-label="books table"
                    size={dense ? "small" : "medium"}
                  >
                    <TableHead>
                      <TableRow>
                        {/* Checkbox for select all */}
                        <TableCell
                          padding="checkbox"
                          sx={{
                            backgroundColor: "#17479e",
                            fontWeight: 600,
                          }}
                        >
                          <Checkbox
                            checked={selectAll}
                            indeterminate={
                              selectedBooks.length > 0 &&
                              selectedBooks.length < books.length
                            }
                            onChange={handleSelectAllChange}
                            color="primary"
                            sx={{ color: "#ffffff" }}
                          />
                        </TableCell>

                        {/* Dynamically generated columns */}
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            sx={{
                              backgroundColor: "#17479e",
                              color: "white",
                              fontWeight: 600,

                              minWidth:
                                column.id === "title" ? "150px" : "auto",
                              ...column.css,
                            }}
                            sortDirection={
                              orderBy === column.id ? order : false
                            }
                          >
                            <Box>
                              {column.sortable ? (
                                <TableSortLabel
                                  active={orderBy === column.id}
                                  direction={
                                    orderBy === column.id ? order : "asc"
                                  }
                                  onClick={() => handleRequestSort(column.id)}
                                  sx={whiteSortLabelSx}
                                >
                                  {column.label}
                                </TableSortLabel>
                              ) : (
                                column.label
                              )}
                              {column.filterable && (
                                <IconButton
                                  size="small"
                                  onClick={() => toggleFilter(column.id)}
                                  sx={{ color: "#fff" }}
                                >
                                  {filterOpen[column.id] ? (
                                    <FilterListOffIcon
                                      sx={{ fontSize: "14px" }}
                                    />
                                  ) : (
                                    <FilterListIcon sx={{ fontSize: "14px" }} />
                                  )}
                                </IconButton>
                              )}
                            </Box>
                            {filterOpen[column.id] && (
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder={`Search ${column.label}`}
                                value={columnFilters[column.id]}
                                onChange={(e) =>
                                  handleColumnFilterChange(
                                    column.id,
                                    e.target.value,
                                  )
                                }
                                sx={{
                                  mt: 1,
                                  width: "100%",
                                  "& .MuiInputBase-root": {
                                    minHeight: "15px", // Increase input box height

                                    color: "#fff", // text color inside input
                                    "& fieldset": {
                                      borderColor: "#ffffffff", // border color
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#ffffffff", // border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#ffffffff", // border color when focused
                                    },
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    py: 0.5, // Optional: adjust vertical padding of text
                                  },
                                }}
                              />
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedBooks
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((book, index) => {
                          return (
                            <TableRow
                              key={book.id}
                              hover
                              sx={{
                                cursor: "pointer",
                                "&:nth-of-type(odd)": {
                                  backgroundColor: "rgba(0, 0, 0, 0.02)",
                                },
                                "&:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                                },
                              }}
                              onClick={(event) =>
                                handleRowClick(event, book.id)
                              }
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={selectedBooks.includes(book.id)}
                                  onChange={(event) =>
                                    handleCheckboxChange(event, book.id)
                                  }
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell sx={{ fontWeight: 500 }}>
                                {book.id}
                              </TableCell>
                              <TableCell sx={{ maxWidth: 200 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 500,
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {book.title}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ minWidth: 200 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 500,
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {/* {uniqueUniversityIds?.length > 0
                                    ? uniqueUniversityIds.join(", ")
                                    : " - "} */}
                                  {Array.from(
                                    new Map(
                                      book.courseRegulations?.map((item) => [
                                        item.universityId,
                                        item.universityName,
                                      ]),
                                    ).values(),
                                  ).join(", ") || " - "}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ minWidth: 250 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 500,
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {Array.from(
                                    new Map(
                                      book.courseRegulations?.map((item) => [
                                        item.courseId,
                                        item.courseName,
                                      ]),
                                    ).values(),
                                  ).join(", ") || " - "}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ maxWidth: 200 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 500,
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {Array.from(
                                    new Map(
                                      book.courseRegulations?.map((item) => [
                                        item.regulationId,
                                        item.regulationName,
                                      ]),
                                    ).values(),
                                  ).join(", ") || " - "}
                                </Typography>
                              </TableCell>

                              <TableCell sx={{ maxWidth: 200 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 500,
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {Array.from(
                                    new Map(
                                      book.courseRegulations?.map((item) => [
                                        item.semesterId,
                                        item.semesterName,
                                      ]),
                                    ).values(),
                                  ).join(", ") || " - "}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{}}>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {book.abbreviation || "-"}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{}}>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500 }}
                                >
                                  ₹{book.price || "0"}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2">
                                  {book.discount ? `${book.discount}%` : "-"}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500 }}
                                  >
                                    {book.rating || "0"}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    ⭐
                                  </Typography>
                                </Box>
                              </TableCell>
                              {/* <TableCell sx={{ padding: "0" }}>
                              <Tooltip
                                title={
                                  book.requestable
                                    ? "This book will be shown to users in the dropdown for raising a new book request"
                                    : book.active
                                    ? "This book is currently active and available"
                                    : "This book is inactive"
                                }
                                arrow
                                placement="top"
                                enterDelay={500}
                              >
                                <Box sx={{ display: "inline-block" }}>
                                  {getStatusChip(book)}
                                </Box>
                              </Tooltip>
                            </TableCell> */}
                              <TableCell>
                                {getBooleanChip(book.requestable)}
                              </TableCell>
                              <TableCell>
                                {getBooleanChip(book.viewable)}
                              </TableCell>
                              <TableCell>
                                {getBooleanChip(book.active)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  position: "sticky",
                                  right: 0,
                                  background: "#fff",
                                  zIndex: 1,
                                }}
                              >
                                <Stack direction="row" spacing={0.5}>
                                  <CanAccess component="BOOK_EDIT_ICON">
                                    <Tooltip
                                      title="Edit Book"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="primary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditOpen(book);
                                        }}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "primary.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </CanAccess>

                                  <CanAccess component="BOOK_UPLOAD_FILES_ICON">
                                    <Tooltip
                                      title="Upload Files"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="info"
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          handleRowClick(event, book.id);
                                        }}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "info.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <UploadFileIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </CanAccess>

                                  <CanAccess component="BOOK_CONTENT_ICON">
                                    <Tooltip
                                      title="Book Units"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="success"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleBookConetnt(book.id);
                                        }}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "success.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <AutoStoriesIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </CanAccess>

                                  <CanAccess component="BOOK_FILES_ICON">
                                    <Tooltip
                                      title="Book Files"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="warning"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleBookFiles(book.id, book.title);
                                        }}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "warning.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <SourceIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </CanAccess>

                                  <CanAccess component="BOOK_DUPLICATE_ICON">
                                    <Tooltip
                                      title="Duplicate Book"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        color="secondary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDuplicateOpen(book);
                                        }}
                                        size="small"
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "secondary.light",
                                            color: "white",
                                          },
                                        }}
                                      >
                                        <ContentCopyIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </CanAccess>
                                </Stack>
                              </TableCell>
                            </TableRow>
                          );
                        })}

                      {/* Empty State */}
                      {books.filter((book) =>
                        book.title
                          .toLowerCase()
                          .includes(searchQuery.toLowerCase()),
                      ).length === 0 &&
                        !isLoading && (
                          <TableRow>
                            <TableCell
                              colSpan={11}
                              sx={{ textAlign: "center", py: 4 }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Typography variant="h6" color="text.secondary">
                                  {searchQuery
                                    ? "No books found matching your search"
                                    : "No books available"}
                                </Typography>
                                {searchQuery && (
                                  <Button
                                    variant="outlined"
                                    onClick={() => setSearchQuery("")}
                                    startIcon={<SearchIcon />}
                                  >
                                    Clear Search
                                  </Button>
                                )}
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 30, 50, 100, 200]}
                  component="div"
                  count={sortedBooks.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    borderTop: "1px solid",
                    borderColor: "divider",
                    "& .MuiTablePagination-toolbar": {
                      paddingLeft: 2,
                      paddingRight: 2,
                    },
                  }}
                />
              </Paper>
            </Fade>
          ) : (
            <Box
              sx={{
                py: 10,
                textAlign: "center",
                backgroundColor: "#f9f9f9",
                border: "1px solid #ddd",
                borderRadius: 2,
                mt: 3,
              }}
            >
              <Typography variant="h6" color="text.secondary">
                🚫 You do not have permission to view the book list.
              </Typography>
            </Box>
          )}
        </>
      )}

      {/* Reprocess Modal */}
      <Modal open={openReprocess} onClose={handleReprocessClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: 330, md: 400 },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {isBulkReprocess ? "Reprocess Multiple Books" : "Reprocess Book"}
          </Typography>

          <Typography variant="body2" sx={{ mb: 2 }}>
            {isBulkReprocess ? (
              <>
                Books selected: <strong>{selectedBooks.length}</strong>
              </>
            ) : (
              <>
                Book: <strong>{selectedBookForReprocess?.title}</strong>
              </>
            )}
          </Typography>

          <FormControl fullWidth margin="normal">
            <InputLabel>Book Part Type</InputLabel>
            <Select
              value={bookPartType}
              onChange={(e) => setBookPartType(e.target.value)}
              label="Book Part Type"
            >
              {bookPartTypesList.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleReprocessClose} color="secondary">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleReprocess}
              disabled={!bookPartType || isReprocessing}
              startIcon={isReprocessing ? <CircularProgress size={20} /> : null}
            >
              {isReprocessing ? "Processing..." : "Reprocess"}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Duplicate Book Modal */}
      <Modal open={openDuplicate} onClose={handleDuplicateClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: 400, xs: 330 },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Duplicate Book
          </Typography>

          <Typography variant="body2" sx={{ mb: 2 }}>
            Original Book: <strong>{selectedBookForDuplicate?.title}</strong>
          </Typography>

          <TextField
            fullWidth
            label="New Book Title"
            value={newBookTitle}
            onChange={(e) => setNewBookTitle(e.target.value)}
            margin="normal"
            variant="outlined"
            placeholder="Enter title for the duplicated book"
            helperText="This will create a complete copy of the book with all its content and settings"
          />
          <FormControl
            fullWidth
            sx={{ marginBottom: "8px", marginTop: "16px" }}
          >
            <InputLabel id="active-label">Select Duplicate Type</InputLabel>
            <Select
              labelId="active-label"
              id="active"
              label="Select Duplicate Type"
              required
              value={selectDuplicate}
              onChange={(e) => setSelectDuplicate(e.target.value)}
            >
              <MenuItem value="Complete_book">Complete Book</MenuItem>
              <MenuItem value="Book_part_type">Select Book Part Types</MenuItem>
            </Select>
          </FormControl>
          {selectDuplicate === "Book_part_type" && (
            <FormControl
              fullWidth
              sx={{ marginBottom: "8px", marginTop: "16px" }}
            >
              <InputLabel id="active-label">Book Part type</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                multiple
                label="Book Part type"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 400,
                    },
                  },
                }}
                value={bookPartTypes}
                onChange={(e) => setBookPartTypes(e.target.value)}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={value}
                        onDelete={(e) => {
                          // stop opening the menu
                          e.stopPropagation();
                          setBookPartTypes((prev) =>
                            prev.filter((item) => item !== value),
                          );
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    ))}
                  </Box>
                )}
              >
                {Books_part_types.map((book) => (
                  <MenuItem value={book.value}>{book.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleDuplicateClose} color="secondary">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDuplicateBook}
              disabled={!newBookTitle.trim() || isDuplicating}
              startIcon={isDuplicating ? <CircularProgress size={20} /> : null}
            >
              {isDuplicating ? "Duplicating..." : "Duplicate Book"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
export default BookDetails;
